import { restHeartClient } from '@/network'
import { AxiosRequestConfig } from 'axios'

/**
 *
 * @param db
 * @param collection
 * @param fileId
 * @param requestConfig
 */
export const getFileContent = (db: string, collection: string, fileId: string, requestConfig?: AxiosRequestConfig | undefined) => {
	return restHeartClient.get(`${db}/${collection}.files/${fileId}/binary`, requestConfig)
}
